// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminUsersController from "./admin_users_controller"
application.register("admin-users", AdminUsersController)

import AutoLoadController from "./auto_load_controller"
application.register("auto-load", AutoLoadController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChartsController from "./charts_controller"
application.register("charts", ChartsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ColorListController from "./color_list_controller"
application.register("color-list", ColorListController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FilmstripController from "./filmstrip_controller"
application.register("filmstrip", FilmstripController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FooterController from "./footer_controller"
application.register("footer", FooterController)

import ImageFileController from "./image_file_controller"
application.register("image-file", ImageFileController)

import LandingVideoController from "./landing_video_controller"
application.register("landing-video", LandingVideoController)

import LivePreviewController from "./live_preview_controller"
application.register("live-preview", LivePreviewController)

import LivestreamController from "./livestream_controller"
application.register("livestream", LivestreamController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MoodsController from "./moods_controller"
application.register("moods", MoodsController)

import MusicApiController from "./music_api_controller"
application.register("music-api", MusicApiController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NavbarCtaToggleVisibilityController from "./navbar_cta_toggle_visibility_controller"
application.register("navbar-cta-toggle-visibility", NavbarCtaToggleVisibilityController)

import NewAssetModalController from "./new_asset_modal_controller"
application.register("new-asset-modal", NewAssetModalController)

import PostTypeController from "./post_type_controller"
application.register("post-type", PostTypeController)

import PostVisibilityController from "./post_visibility_controller"
application.register("post-visibility", PostVisibilityController)

import ProfileImageController from "./profile_image_controller"
application.register("profile-image", ProfileImageController)

import ReportsFilterController from "./reports_filter_controller"
application.register("reports-filter", ReportsFilterController)

import RoutineIndexTabsController from "./routine_index_tabs_controller"
application.register("routine-index-tabs", RoutineIndexTabsController)

import RoutineScheduleController from "./routine_schedule_controller"
application.register("routine-schedule", RoutineScheduleController)

import RoutineTabsController from "./routine_tabs_controller"
application.register("routine-tabs", RoutineTabsController)

import ScheduleDayController from "./schedule_day_controller"
application.register("schedule-day", ScheduleDayController)

import ScrollContainerController from "./scroll_container_controller"
application.register("scroll-container", ScrollContainerController)

import SequenceItemController from "./sequence_item_controller"
application.register("sequence-item", SequenceItemController)

import ShredFooterToggleVisibilityController from "./shred_footer_toggle_visibility_controller"
application.register("shred-footer-toggle-visibility", ShredFooterToggleVisibilityController)

import SidenavController from "./sidenav_controller"
application.register("sidenav", SidenavController)

import SortOrderController from "./sort_order_controller"
application.register("sort-order", SortOrderController)

import SpinController from "./spin_controller"
application.register("spin", SpinController)

import TagController from "./tag_controller"
application.register("tag", TagController)

import TimestampController from "./timestamp_controller"
application.register("timestamp", TimestampController)

import TimestamperController from "./timestamper_controller"
application.register("timestamper", TimestamperController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import VideoSequenceController from "./video_sequence_controller"
application.register("video-sequence", VideoSequenceController)

import WorkoutSocketController from "./workout_socket_controller"
application.register("workout-socket", WorkoutSocketController)

import WorkoutVideoController from "./workout_video_controller"
application.register("workout-video", WorkoutVideoController)

import WorkoutVisibilityController from "./workout_visibility_controller"
application.register("workout-visibility", WorkoutVisibilityController)
